import { getCookiePubKey, getFileDomain, getLongitude, getLatitude, getUsedSystem } from './auth'
import md5 from 'js-md5';
import { JSEncrypt } from 'jsencrypt'
import Element, { Message } from 'element-ui'
import i18n from '../i18n' 
import Clipboard from 'clipboard'
import moment from 'moment'
import store from '@/store'

export function crypto(password) {
  if (getCookiePubKey()) {
    var encrypt = new JSEncrypt();
    encrypt.setPublicKey(getCookiePubKey());
    var cryptoData = formatStr(password);
    cryptoData = encrypt.encrypt(cryptoData);
    return cryptoData;
  } else {
    return ''
  }
}

export function getBrowser() {
  var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
    var isOpera = userAgent.indexOf('Opera') > -1;
    if (isOpera) { // 判断是否Opera浏览器
        return 'opera'
    }; 
    if (userAgent.indexOf('Firefox') > -1) { // 判断是否Firefox浏览器
        return 'firefox';
    } 
    if (userAgent.indexOf('Chrome') > -1) { // 判断是否Chrome浏览器
      return 'chrome';
    }
    if (userAgent.indexOf('Safari') > -1) { // 判断是否Safari浏览器
        return 'safari';
    } 
    if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera) {//判断是否IE浏览器
        return 'ie';
    };  
}

export function encodeURIParam(query) {
  // if (typeof query === 'string') {
  //   return encodeURI(query);
  // } else if (typeof str === 'object') {
  //   return encodeURI(JSON.stringify(query));
  // } else {
    return query;
  // }
}

export function formatStr(p) {
  var encryptData = md5(p).toString();
  encryptData = shiftLeft(encryptData, 2);
  encryptData = md5(encryptData).toString();
  encryptData = shiftLeft(encryptData, 2);
  encryptData = md5(encryptData).toString();
  return encryptData;
}

export function shiftLeft(str, n) {
  var len = str.length;
  n = n % len;
  return str.substring(n, len) + str.substring(0, n);
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/gi) != null) {
      len += 1
    } else {
      len += 0.5
    }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"') +
    '"}'
  )
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }
]

export function formatDate(value, format) {
  if (value === undefined || value === "" || value === "0000-00-00 00:00:00") {
    return "";
  }
  if (format === undefined) {
    format = 'YYYY-MM-DD'
  }
  let rtn = moment(value).format(format);
  return rtn === "Invalid date" ? "" : rtn;
}

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result
  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function notify(messge, callback) {
  let options = {
    title: i18n.t('public.operate'),
    message: messge,
    type: 'success',
    duration: 1000
  }
  if (callback !== undefined) {
    options.onClose = callback
  }
  Element.Message(options)
}

export function havaRight(menuid) {
  // console.log(menuid)
  // console.log(store.getters.userRemoteMenuIds)
  return store.getters.userRemoteMenuIds.indexOf(menuid) >= 0;
}

// 获得某月的天数
export function getMonthDays(nowYear, myMonth) {
  var monthStartDate = new Date(nowYear, myMonth, 1);
  var monthEndDate = new Date(nowYear, myMonth + 1, 1);
  var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
  return days;
}

export function handleClipboard(text, event) {
  const clipboard = new Clipboard(event.target, {
    text: () => text
  })
  clipboard.on('success', () => {
    let options = {
      title: '复制操作',
      message: '成功',
      type: 'success',
      duration: 500
    }
    Element.Notification(options)
    clipboard.off('error')
    clipboard.off('success')
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    let options = {
      title: '复制操作',
      message: '失败',
      type: 'error',
      duration: 500
    }
    Element.Notification(options)
    clipboard.off('error')
    clipboard.off('success')
    clipboard.destroy()
  })
  clipboard.onClick(event)
}

export function formatNum(value, decimal) {
  if (decimal === undefined) {
    decimal = 2
  }
  // 截取当前数据到小数点后两位
  let realVal = parseFloat(value).toFixed(decimal)
  // num.toFixed(2)获取的是字符串
  return parseFloat(realVal)
}

// 校验密码强度
export function checkPassWord(value) {
  // 0： 表示第一个级别 1：表示第二个级别 2：表示第三个级别
  // 3： 表示第四个级别 4：表示第五个级别
  var modes = 0;
  if (value.length < 6) { // 最初级别
    return modes;
  }
  if (/\d/.test(value)) { // 如果用户输入的密码 包含了数字
    modes++;
  }
  if (/[a-z]/.test(value)) { // 如果用户输入的密码 包含了小写的a到z
    modes++;
  }
  if (/[A-Z]/.test(value)) { // 如果用户输入的密码 包含了大写的A到Z
    modes++;
  }
  if (/\W/.test(value)) { // 如果是非数字 字母 下划线
    modes++;
  }
  return modes;
}

/**
 * 判断是否JSON字符串
 * @param {*} str 
 */
export function isJSON(str) {
  try {
    if (typeof JSON.parse(str) === 'object') {
      return true;
    }
  } catch (e) {
  }
  return false;
} 

/**
 * 获得经纬度，如果未空，默认项目的经纬度
 * @param {*} longitude 
 * @param {*} latitude 
 */
export function getPosition(longitude, latitude) {
  let _longitude = getLongitude();
  let _latitude = getLatitude();
 
    if (longitude !== undefined && longitude !== '') {
      _longitude = longitude;
    } 
    if (latitude !== undefined && latitude !== '') {
      _latitude = latitude;
    } 
  return [_longitude, _latitude];
} 

/**
 * 图片网址增加时间搓
 * @param {*} url 
 */
export function getImageUrlAddTime(url) {  
  if (url === undefined || url == null || url === '') {
    return '';
  }
  // 如果是网址
  if (url.indexOf('data:image') === -1) {
     let rtn = '';
     if (url.indexOf('?t') === -1) {
      rtn = url + '?t=' + (new Date().getTime());
     } else {
      rtn = url.split('?')[0] + '?t=' + (new Date().getTime()); 
     } 
     if (rtn.indexOf(getFileDomain()) === -1) {
        return getFileDomain() + rtn;
     }
     return rtn;
  } else { 
    // 如果是图片
    return url;
  }
} 

/**
 * 图片去掉时间搓
 * @param {*} url 
 */
export function getImageUrlNoTime(url) {  
  if (url === undefined || url === null || url === '') {
    return '';
  }
  // 如果是网址
  if (url.indexOf('data:image') === -1) {
     let rtn = '';
     if (url.indexOf('?t') !== -1) {
      rtn = url.split('?')[0];
     } else {
      rtn = url;
     }  
     if (rtn.indexOf(getFileDomain()) !== -1) {
      return rtn.replace(getFileDomain(), '');
    }
    return rtn;
  } else { 
    // 如果是图片
    return url;
  }
}  

// 获取当前浏览器类型和版本号

export function getBrowserInfo() { 
    var agent = navigator.userAgent.toLowerCase();  
    var regStr_edge = /edge\/[\d.]+;/gi;
    var regStr_ie = /msie [\d.]+;/gi;
    var regStr_ff = /firefox\/[\d.]+/gi;
    var regStr_chrome = /chrome\/[\d.]+/gi;
    var regStr_saf = /safari\/[\d.]+/gi;
    if (agent.indexOf('edge') > 0) {
        return agent.match(regStr_edge);
    }
    // IE11以下
    if (agent.indexOf('msie') > 0) {
        return agent.match(regStr_ie);
    }

    // IE11版本中不包括MSIE字段
    if (agent.indexOf('trident') > 0 && agent.indexOf('rv') > 0) {
        return 'IE ' + agent.match(/rv:(\d+\.\d+)/)[1];
    }

    // firefox
    if (agent.indexOf('firefox') > 0)
    {
        return agent.match(regStr_ff);
    }

    // Chrome
    if (agent.indexOf('chrome') > 0) {
        return agent.match(regStr_chrome);
    }

    // Safari
    if (agent.indexOf('safari') > 0 && agent.indexOf('chrome') < 0) {
        return agent.match(regStr_saf);
    }
}

export function hasUserSystem(typeid) {
  let data = getUsedSystem()
  if (data === undefined) {
    return false;
  } 
  return (data.indexOf(typeid) === -1);
}



// WEBPACK FOOTER //
// ./src/utils/index.js